/**
 * Main application entry point.
 *
 * Bundles all web components and initializes client-side functionality.
 * This file is bundled with all dependencies during build.
 *
 * Precondition: DOM ready
 * Postcondition: All web components registered, IndexedDB initialized
 */

// Patch history API to emit navigation events (must run before components load)
const originalPushState = history.pushState.bind(history);
history.pushState = function (...args) {
  originalPushState(...args);
  window.dispatchEvent(new Event("pushstate"));
};

// Handle browser back/forward navigation for quarter pages
window.addEventListener("popstate", () => {
  const match = location.pathname.match(/\/companies\/(\d+)\/(\d{4}-Q[1-4])$/);
  if (match) {
    const [, , quarter] = match;
    // Dispatch quarter-change event to update components
    document.dispatchEvent(
      new CustomEvent("quarter-change", {
        bubbles: true,
        detail: { quarter },
      }),
    );
    // Update the quarter selector dropdown
    const selector = document.querySelector("ft-company-quarter") as any;
    if (selector?.setQuarter) {
      selector.setQuarter(quarter);
    }
  }
});

// Lib utilities
import { initErrorToast } from "./lib/error-toast.js";

// Web components - core layout
import "./web-components/button/button.js";
import "./web-components/theme-toggle/theme-toggle.js";
import "./web-components/app-layout/app-layout.js";
import "./web-components/collapsible-sidebar/collapsible-sidebar.js";
import "./web-components/sidebar-item/sidebar-item.js";
import "./web-components/app-header/app-header.js";
import "./web-components/app-footer/app-footer.js";

// Web components - search
import "./web-components/search-button/search-button.js";
import "./web-components/spotlight-search/spotlight-search.js";
import "./web-components/filer-search/filer-search.js";

// Web components - UI primitives
import "./web-components/dialog/dialog.js";
import "./web-components/disclosure/disclosure.js";
import "./web-components/toast/toast.js";
import "./web-components/consent-banner/consent-banner.js";
import "./web-components/card/card.js";
import "./web-components/tabs/tabs.js";
import "./web-components/button-chip/button-chip.js";
import "./web-components/multi-select-buttons/multi-select-buttons.js";
import "./web-components/timeline/timeline.js";
import "./web-components/spinner/spinner.js";
import "./web-components/dropdown/dropdown.js";
import "./web-components/select/select.js";

// Web components - domain specific
import "./web-components/favorite-button/favorite-button.js";
import "./web-components/company-quarter/company-quarter.js";
import "./web-components/company-card/company-card.js";
import "./web-components/holdings-table/holdings-table.js";
import "./web-components/analytics-panel/analytics-panel.js";
import "./web-components/portfolio-composition/portfolio-composition.js";
import "./web-components/filings-timeline/filings-timeline.js";
import "./web-components/table-filter/table-filter.js";
import "./web-components/signup-cta/signup-cta.js";
import "./web-components/pricing-table/pricing-table.js";
import "./web-components/hero-smart-money/hero-smart-money.js";
import "./web-components/superinvestors/superinvestors.js";

// Web components - chat
import "./web-components/chat/chat.js";

// Initialize global error handling
initErrorToast();
